<template>
    <v-dialog v-model="dialog" max-width="900" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.list_evaluations') }}
            </v-card-title>
            <v-card-text class="mt-6">
                <v-row>
                    <v-col cols="12">
                        <v-data-table :headers="headers" :loading="loading" :items="currentEvaluations"
                            :mobile-breakpoint="0" hide-default-footer :loading-text="$t('common.loading')"
                            :no-data-text="$t('common.not_found')">
                            <template v-slot:item.actions="{ item }">
                                <v-btn class="mr-1 mb-1" fab small depressed @click="editTemplate(item)">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn class="mr-1 mb-1" fab small depressed @click="deleteTemplate(item)">
                                    <v-icon>$delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12">
                        <v-alert color="pink" dark border="left" dismissible outlined>
                            <small>{{ $t('common.max_evaluations_reminder') }}</small>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <create-evaluation-dialog ref="evaluation" is-second-dialog />

        <!-- DELETE TEMPLATE -->
        <kimsa-confirm ref="delete" :title="$t('common.delete_template')" is-second-dialog
            :content="$t('common.delete_template_content')" :persistent="false" :loading="loadingDelete"
            @confirm="deleteEvaluation" @cancel="evaluationId = null" :close-on-confirm="false" :alert-mode="true" />
    </v-dialog>
</template>

<script>
import CreateEvaluationDialog from "@/components/coach/CreateEvaluationDialog";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import { mapActions, mapState, mapMutations } from "vuex";
import { db } from "@/utils/Firebase";

export default {
    components: { KimsaConfirm, CreateEvaluationDialog },
    name: "EvaluationsListDialog",
    data(vm) {
        return {
            dialog: false,
            loading: false,
            evaluationId: null,
            headers: [
                { text: vm.$t('common.name'), value: 'name' },
                { text: vm.$t('common.evaluations'), value: 'evaluations' },
                { text: '', value: 'actions', sortable: false },
            ],
            loadingDelete: false,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'evaluations']),
        disabled(vm = this) {
            return !vm.selectedEvaluation
        },
        currentEvaluations(vm = this) {
            return vm.evaluations?.map(evaluation => ({ ...evaluation, id: evaluation.id, evaluations: evaluation.config.length })) || []
        }
    },
    async mounted() {
        const vm = this
        vm.loading = true
        if (vm.evaluations.length === 0) await vm.bindEvaluations(vm.currentUser.uid)
        vm.loading = false
    },
    methods: {
        ...mapActions(['bindEvaluations']),
        ...mapMutations(['setDialogActive']),
        show(currentId) {
            const vm = this
            vm.currentId = currentId
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        editTemplate(evaluation) {
            const vm = this
            vm.$refs.evaluation.loadEvaluation(evaluation)
        },
        deleteTemplate(evaluation) {
            const vm = this
            vm.evaluationId = evaluation.id
            vm.$refs.delete.show()
        },
        async deleteEvaluation() {
            const vm = this
            vm.loadingDelete = true
            await db.collection('evaluations').doc(vm.evaluationId).delete()
            let assignedRef = await db.collection('assignedEvaluations')
                .where('evaluationId', '==', vm.evaluationId).get()
            for (let assigned of assignedRef.docs)
                await db.collection('assignedEvaluations').doc(assigned.id).delete()
            let studentRef = await db.collection('users')
                .where('assignedEvaluationId', '==', vm.evaluationId).get()
            for (let student of studentRef.docs)
                await db.collection('users').doc(student.id).update({ assignedEvaluationId: null })
            vm.toast(vm.$t('common.template_deleted'))
            vm.evaluationId = null
            vm.$refs.delete.hide()
            vm.loadingDelete = false
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

>>>.v-data-table-header>tr {
    box-shadow: 3px 3px 6px 0 rgba(1, 55, 46, 0.1) !important;
}

>>>tbody>tr {
    box-shadow: 3px 3px 6px 0 rgba(1, 55, 46, 0.1) !important;
}

>>>tbody>tr>td {
    border: none !important;
    padding-top: 8px !important;
    padding-bottom: 4px !important;
}

>>>.v-data-table__wrapper {
    overflow: visible;
}

>>>.v-data-table-header>tr>th {
    border: none !important;
}

>>>.v-data-table-header>tr>th>span {
    font-weight: bold !important;
}
</style>